module.exports = __webpack_public_path__ + "img/user2.e5fe05c5.svg";